import React from 'react'

import '../../App.css'
import HomeMainbar from '../../components/HomeMainbar/HomeMainbar'

const Posts = () => {
  return (
    <div className='home-container-2'>
        <HomeMainbar />
    </div>
  )
}

export default Posts